export const CLICK_AND_COLLECT = 'ClickAndCollect';
export const CLICK_AND_COLLECT_MIN_VALUE = 40;
export const DELIVERY_MIN_VALUE = 50;
export const PARTNERSHIP_STORE = 'PartnershipStore';
export const COLLECT_PLUS = 'CollectPlus';
export const ROYAL_MAIL = 'RoyalMail';
export const ROYAL_MAIL_NAME = 'Royal Mail';
export const EVRI = 'EVRi';
export const DPD = 'DPD';
export const VIEW_TYPE_LIST = 'search-list';
export const VIEW_TYPE_MAP = 'search-map';
export const STORE_SELECTED = 'store-selected';
export const STORE_DETAILS = 'store-details';
export const JOHN_LEWIS_OWNER_ID = 1;
export const WAITROSE_OWNER_ID = 2;
export const BOOTHS_OWNER_ID = 4;
export const ROYAL_MAIL_OWNER_ID = 10;
export const EVRI_OWNER_ID = 11;
export const DPD_OWNER_ID = 13;
export const COLLECT_PLUS_RELATED_OWNERS = [
  {
    name: ROYAL_MAIL_NAME,
    ownerId: ROYAL_MAIL_OWNER_ID,
    type: ROYAL_MAIL,
    collectionCodeDescription: 'unique 7 character collection code',
    onBehalfPhotoIdPhrase: 'your',
    retentionDays: 18,
    url: 'https://help.royalmail.com/personal/s/article/How-to-collect-with-Local-Collect#:~:text=Once%20we%27ve%20left%20your,hold%20items%20for%2018%20days',
  },
  {
    name: EVRI,
    ownerId: EVRI_OWNER_ID,
    type: EVRI,
    collectionCodeDescription: 'unique 7 character collection code',
    onBehalfPhotoIdPhrase: 'their own',
    retentionDays: 10,
  },
  {
    name: DPD,
    ownerId: DPD_OWNER_ID,
    type: DPD,
    collectionCodeDescription: 'collection code',
    onBehalfPhotoIdPhrase: 'your',
    retentionDays: 7,
  },
];
